import macOsSvg from '@/assets/device-icons/macos.svg';

interface MacOsIconProps {
  className?: string;
}

export const MacOsIcon = ({ className = "h-5 w-5" }: MacOsIconProps) => {
  return (
    <img 
      src={macOsSvg} 
      alt="macOS" 
      className={className}
    />
  );
};
